import db from "./firebase";

export function validateEmail(email) {
    // eslint-disable-next-line no-useless-escape
    const validation = /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/;
    return validation.test(String(email).toLowerCase());
}

export const morePeliculas =async (type,limite,startPeliculas) =>{

    const result = {statusResponse: true, error: null, peliculas:[], startPeliculas: null}
    try{
        const response = await db.collection("peliculas").where("type","==",type).orderBy("createAt", "desc").startAfter(startPeliculas.data().createAt).limit(limite).get()
        if(response.docs.length > 0){
            result.startPeliculas = response.docs[response.docs.length -1]
        }
        response.docs.map((doc) =>{
            const comentario = doc.data()
            comentario.id=doc.id
            result.peliculas.push(comentario)
        })
    }catch (error){
        result.statusResponse=false
        result.error=error
    }
    return result
}
export const morePeliculasSinType =async (limite,startPeliculas) =>{

    const result = {statusResponse: true, error: null, peliculas:[], startPeliculas: null}
    try{
        const response = await db.collection("peliculas").orderBy("createAt", "desc").startAfter(startPeliculas.data().createAt).limit(limite).get()
        if(response.docs.length > 0){
            result.startPeliculas = response.docs[response.docs.length -1]
        }
        response.docs.map((doc) =>{
            const comentario = doc.data()
            comentario.id=doc.id
            result.peliculas.push(comentario)
        })
    }catch (error){
        result.statusResponse=false
        result.error=error
    }
    return result
}

export const moreSeries =async (limite,startSeries) =>{

    const result = {statusResponse: true, error: null, series:[], startSeries: null}
    try{
        const response = await db.collection("series").orderBy("createAt", "desc").startAfter(startSeries.data().createAt).limit(limite).get()
        if(response.docs.length > 0){
            result.startSeries = response.docs[response.docs.length -1]
        }
        response.forEach((doc) =>{
            const serie = doc.data()
            serie.id=doc.id
            result.series.push(serie)
        })
    }catch (error){
        result.statusResponse=error
        result.error=error
    }
    return result
}

export const agregarCaracter = (cadena, caracter, pasos) => {
    let cadenaConCaracteres = "";
    const longitudCadena = cadena.length;
    for (let i = 0; i < longitudCadena; i += pasos) {
        if (i + pasos < longitudCadena) {
            cadenaConCaracteres += cadena.substring(i, i + pasos) + caracter;
        } else {
            cadenaConCaracteres += cadena.substring(i, longitudCadena);
        }
    }
    return cadenaConCaracteres;
}